import { FC } from "react";
import styled from "styled-components";

const RadioButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: flex-start;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 165.5%;
	align-items: center;
	letter-spacing: 0.005em;
	gap: 6px;
	user-select: none;
	width: fit-content;
`;

const UncheckedIndicator = styled.div`
	width: 14px;
	height: 14px;
	border: 1px solid #23263b;
	border-radius: 14px;
	box-sizing: border-box;
`;

const CheckedIndicator = styled.div`
	width: 14px;
	height: 14px;
	border: 3px solid ${props => props.theme.colors.primary};
	border-radius: 12px;
	box-sizing: border-box;
`;

interface RadioButtonProps {
	value: boolean;
	onChange: (value: boolean) => void;
	label?: string;
}

const RadioButton: FC<RadioButtonProps> = props => {
	return (
		<RadioButtonWrapper onClick={() => props.onChange(!props.value)}>
			{props.value ? <CheckedIndicator /> : <UncheckedIndicator />}
			{props.label && props.label}
		</RadioButtonWrapper>
	);
};

export default RadioButton;
